

































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
import moment from 'moment'
@Component
export default class DateTimeRanger extends Vue {
  orderViewType: string = '昨天'
  orderViewDateRange: string[] = [
    moment().format('YYYY-MM-DD 00:00:00'),
    moment().format('YYYY-MM-DD 23:59:59'),
  ]
  orderViewTypeChange(value) {
    console.log(value);
    this.orderViewDateRange = this.getDateRange(value)
    this.$emit('on-change', this.orderViewDateRange, value)
  }
  orderViewDateChange(value) {
    this.orderViewDateRange = value
    this.$emit('on-change', this.orderViewDateRange)
  }
  getDateRange(type: string): string[] {
    if (type == '最近7天') {
      return [
        moment().subtract(7, 'days').format('YYYY-MM-DD 00:00:00'),
        moment().format('YYYY-MM-DD 23:59:59'),
      ]
    }
    if (type == '最近30天') {
      return [
        moment().subtract(30, 'days').format('YYYY-MM-DD 00:00:00'),
        moment().format('YYYY-MM-DD 23:59:59'),
      ]
    }
    return [
      moment().subtract(1, 'days').format('YYYY-MM-DD 00:00:00'),
      moment().subtract(1, 'days').format('YYYY-MM-DD 23:59:59'),
    ]
  }
}
